import React from "react";
import AdminUsersComponent from "../../../components/Admin/Users";

export default function AdminUsersPage() {
    return <AdminUsersComponent />;
}
